import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

const Support = () => {
  const {t} = useTranslation();

  return (
    <Container>
      <p>
        {t('dashboard.support')}:{' '}
        <a href="mailto:playeraid@game2value.it">playeraid@game2value.it</a>
      </p>
    </Container>
  );
};

export default Support;

const Container = styled.div`
  max-width: 1100px;
  margin: 70px auto;
  padding: 0 20px;
  text-align: center;

  * {
    font-size: 15px;
    line-height: 1.5;
  }

  a {
    color: ${(p) => p.theme.colors.orange500};
  }
`;
